import api from "./api";

const route = "/appconfig";

const AppConfigService = {
  getAppConfig: () => api.get(route),
};

export default AppConfigService;
